import { gql } from '@apollo/client';

export const TRANSFER_PARCELS = gql`
  mutation TransferParcels($input: TransferParcelsInput!) {
    transferParcels(input: $input) {
      taskId
      status
      message
      errorCode
      failedTrackingNumbers
    }
  }
`;

// ✅ 扁平化为 5 个参数
export interface TransferParcelsInput {
  sourceTaskId: number;
  driverId: number;
  taskDate: string;
  parcelIds: number[];
}

export interface TransferParcelsResponse {
  transferParcels: {
    taskId: number; // 转单任务跟踪ID
    status: string; // PLANNING | COMPLETED | FAILED | UNKNOWN
    message: string;
    errorCode?: string; // 错误码，前端根据此字段做国际化展示
    failedTrackingNumbers?: string[]; // 校验失败的运单号列表
  };
}

